











import Vue from 'vue';

export default Vue.extend({
  name: 'BaseButton',

  inheritAttrs: false,

  props: {
    // 無効化されているかどうか
    disabled: {
      type: Boolean,
    },
    // アウトラインボタンかどうか
    outlined: {
      type: Boolean,
    },
  },

  methods: {
    // クリック時の処理
    onClick(event: Event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
  },
});
